import {
  AUSD,
  BLUE,
  BUCK,
  CETUS,
  CoinInfo,
  DEEP,
  ETH,
  FDUSD,
  haSui,
  LBTC,
  LorenzoBTC,
  NAVX,
  NS,
  nUSDC,
  stSUI,
  Sui,
  suiBTC,
  suiUSDT,
  USDT,
  USDY,
  vSui,
  WAL,
  WBTC,
  WETH,
  WSOL,
  wUSDC,
} from 'navi-sdk'

export const SUPPORTED_COINS: CoinInfo[] = [
  NAVX,
  Sui,
  vSui,
  USDT,
  WETH,
  CETUS,
  haSui,
  WBTC,
  AUSD,
  wUSDC,
  nUSDC,
  ETH,
  USDY,
  NS,
  LorenzoBTC,
  DEEP,
  FDUSD,
  BLUE,
  BUCK,
  suiUSDT,
  stSUI,
  suiBTC,
  WSOL,
  LBTC,
  WAL,
]
